module.exports = __webpack_public_path__ + "img/HoveredDiscordIcon.981a6534.svg";